import { Box } from "@mui/material"

import Dimensions from "components/Dimensions"

import getProductAttributes from "utils/getProductAttributes"

import useTranslation from "hooks/useTranslation"

import { ProductAttributes } from "@secureo/common/typings/ProductAttributes"

export const getLocalizedAttributeValue = (value: string, language: string) => {
	switch (value) {
		case "kein":
			switch (language) {
				case "pl":
					return "brak"
				default:
					return value
			}
		default:
			return value
	}
}

const Attributes = ({ attributes, shortDescription, language }: Props) => {
	const { t, locale } = useTranslation("product")
	const { formattedAttributes, innerDimensions, outerDimensions } =
		getProductAttributes(attributes)

	const showAttributes =
		innerDimensions ||
		outerDimensions ||
		Object.keys(formattedAttributes).length > 1 ||
		shortDescription

	if (!showAttributes) return null

	return (
		<Box mt={3}>
			<div className="bold">{t("atAGlance")}</div>
			<Box mt={1} style={{ color: "#274041" }}>
				{shortDescription ? (
					<p
						dangerouslySetInnerHTML={{
							__html: shortDescription,
						}}
					/>
				) : (
					<ul>
						{innerDimensions && (
							<li>
								<span>{t("innerDimensionsInCm")}: </span>
								<Dimensions
									width={innerDimensions.width}
									height={innerDimensions.height}
									depth={innerDimensions.depth}
									locale={locale}
								/>
							</li>
						)}
						{outerDimensions && (
							<li>
								<span>{t("outerDimensionsInCm")}: </span>
								<Dimensions
									width={outerDimensions.width}
									height={outerDimensions.height}
									depth={outerDimensions.depth}
									locale={locale}
								/>
							</li>
						)}

						{formattedAttributes.map(({ key, value }) => {
							return (
								<li key={key}>
									{t(key) as any}:{" "}
									{getLocalizedAttributeValue(value as any, language)}
								</li>
							)
						})}
					</ul>
				)}
			</Box>
		</Box>
	)
}

interface Props {
	attributes: ProductAttributes
	shortDescription: string
	language: string
}

export default Attributes
